<template>
  <div v-if="data" ref="echars" class="echars-class">

  </div>
</template>

<script>
import {formatMoney} from '@/utils/filters'

export default {
  name: "points",
  data: () => ({
    chats: undefined,
    data: undefined
  }),
  computed: {
    isModel() {
      return this.$vuetify.breakpoint.name === 'xs';
    },
  },
  methods: {
    init(data) {
      this.data = data

      let _model = this.isModel

      let _data = []

      this.data.forEach(item => {
        let {name, title, salary, point} = item

        _data.push({
          name,
          title,
          value: salary,
          point
        })
      })

      let option = {
        xAxis: {
          type: 'category',
          data: this.data.map(item => item.name),
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow"
          },
          formatter(params) {
            let {value, point} = params[0].data
            return `<span>行业内${point}%的人</span><br/><span>低于￥${formatMoney(value)}</span>`
          }
        },
        yAxis: {
          type: 'value',
          axisLabel: {
            formatter(params) {
              if (_model) {
                return `￥${parseInt(params) / 10000}万`
              } else {
                if (params === 0){
                  return '0'
                }
                return `￥${formatMoney(params)}`
              }
            },
          }
        },
        series: [
          {
            label: {
              show: true,
              formatter: "￥ {c} "
            },
            data: _data,
            type: 'line',
          }
        ]
      };
      this.$nextTick(() => {
        this.chats = this.$echarts.init(this.$refs.echars, 'vintage', {renderer: 'canvas'})
        this.chats.setOption(option);
        this.chats.resize();
      })

    },
    resize() {
      this.$nextTick(() => {
        if (this.chats) {
          this.chats.resize();
        }
      })
    }
  }

}
</script>

<style scoped>
.echars-class {
  width: 100%;
  height: 100%;
}
</style>
